import { render, staticRenderFns } from "./AddressProps.vue?vue&type=template&id=9f149c58&"
import script from "./AddressProps.vue?vue&type=script&lang=js&"
export * from "./AddressProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports